import React from 'react'
import Section from '../Section'
import Header, { Title } from '../Header'
import {
  ColorFormat,
  EnablableSection,
  Style as StyleType,
  LayerType,
  ColorVariable,
} from 'modules/shares/types'
import Separator from '../Separator'
import Borders from '../Borders'
import Fills from '../Fills'
import Shadows from '../Shadows'
import Blur from '../Blur'

const isThereContent = (subsection: EnablableSection[]) => {
  return subsection.filter(item => item.isEnabled).length !== 0
}

interface StyleProps {
  style: StyleType
  onColorFormatChange: (f: ColorFormat) => void
  colorFormat: ColorFormat
  layerType?: LayerType
  colorVariables: { [key: string]: ColorVariable }
}

const Style: React.FC<StyleProps> = ({
  style,
  onColorFormatChange,
  colorFormat,
  layerType,
  colorVariables,
}) => {
  const borders =
    style.borders && isThereContent(style.borders) ? (
      <Borders
        borders={style.borders}
        onColorFormatChange={onColorFormatChange}
        colorFormat={colorFormat}
        colorVariables={colorVariables}
        borderOptions={style.borderOptions}
        originalValues={
          style.isDirty ? style.originalSharedStyleValues?.borders : undefined
        }
        originalValuesOptions={
          style.isDirty
            ? style.originalSharedStyleValues?.borderOptions
            : undefined
        }
      />
    ) : null

  const fills =
    style.fills && isThereContent(style.fills) ? (
      <Fills
        fills={style.fills}
        onColorFormatChange={onColorFormatChange}
        colorFormat={colorFormat}
        layerType={layerType}
        colorVariables={colorVariables}
        originalValues={
          style.isDirty ? style.originalSharedStyleValues?.fills : undefined
        }
      />
    ) : null

  const normalShadows =
    style.shadows &&
    isThereContent(style.shadows) &&
    style.shadows.length > 0 ? (
      <Shadows
        shadows={style.shadows}
        onColorFormatChange={onColorFormatChange}
        colorFormat={colorFormat}
        colorVariables={colorVariables}
        originalValues={
          style.isDirty ? style.originalSharedStyleValues?.shadows : undefined
        }
      />
    ) : null

  const innerShadows =
    style.innerShadows && style.innerShadows.length > 0 ? (
      <Shadows
        title="Inner Shadows"
        shadows={style.innerShadows}
        onColorFormatChange={onColorFormatChange}
        colorFormat={colorFormat}
        colorVariables={colorVariables}
        originalValues={
          style.isDirty
            ? style.originalSharedStyleValues?.innerShadows
            : undefined
        }
      />
    ) : null

  const blur =
    style.blur && isThereContent([style.blur]) ? (
      <Blur
        {...style.blur}
        originalValues={
          style.isDirty ? style.originalSharedStyleValues?.blur : undefined
        }
      />
    ) : null

  const content = [fills, borders, normalShadows, innerShadows, blur].filter(
    item => item !== null
  )

  return content.length > 0 ? (
    <>
      <Separator />
      <Section data-testid="inspector-sidebar-style">
        <Header>
          <Title>Style</Title>
        </Header>
        {content.map((element, i) => (
          <React.Fragment key={i}>
            <Separator />
            {element}
          </React.Fragment>
        ))}
      </Section>
    </>
  ) : null
}

export default Style
